<template>
  <v-select
    v-model="selectedEventStatus"
    :items="eventsStatusesList"
    item-text="text"
    item-value="id"
    placeholder="Estatus de Evento"
    outlined
    dense
    :clearable="clearable"
  >
    <template #item="{ item }">
      <v-list-item-icon>
        <v-icon :color="item.color">
          {{ item.icon }}
        </v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ item.text }}</v-list-item-title>
      </v-list-item-content>
    </template>

    <template #selection="{ item }">
      <v-list-item-icon class="pb-0 pt-0 mt-1 mb-0">
        <v-icon :color="item.color">
          {{ item.icon }}
        </v-icon>
      </v-list-item-icon>
      <v-list-item-content class="pb-0 pt-0 mt-0 mb-0">
        <v-list-item-title>{{ item.text }}</v-list-item-title>
      </v-list-item-content>
    </template>
  </v-select>
</template>

<script>
import { computed } from '@vue/composition-api'
import useEventsStatusesList from '@/components/lists/eventsStatuses'

export default {
  props: {
    value: {
      type: Number,
      default: null,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { eventsStatusesList } = useEventsStatusesList()
    const selectedEventStatus = computed({
      get() {
        return props.value
      },
      set(value) {
        // Actualiza el valor del componente y emite el evento "input"
        // para mantener sincronizado el valor con v-model
        return emit('input', value)
      },
    })

    return {
      selectedEventStatus,
      eventsStatusesList,
    }
  },
}
</script>
